var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.313 4 3.5 7.813 3.5 12.5C3.5 17.187 7.313 21 12 21C16.687 21 20.5 17.187 20.5 12.5C20.5 7.813 16.687 4 12 4ZM12 22.5C6.486 22.5 2 18.014 2 12.5C2 6.986 6.486 2.5 12 2.5C17.514 2.5 22 6.986 22 12.5C22 18.014 17.514 22.5 12 22.5Z",
    fill: "#fa4a4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9941 13.8721C11.5801 13.8721 11.2441 13.5361 11.2441 13.1221V8.70312C11.2441 8.28912 11.5801 7.95312 11.9941 7.95312C12.4081 7.95312 12.7441 8.28912 12.7441 8.70312V13.1221C12.7441 13.5361 12.4081 13.8721 11.9941 13.8721Z",
    fill: "#fa4a4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004 17.2969C11.451 17.2969 10.999 16.8499 10.999 16.2969C10.999 15.7439 11.442 15.2969 11.994 15.2969H12.004C12.557 15.2969 13.004 15.7439 13.004 16.2969C13.004 16.8499 12.557 17.2969 12.004 17.2969Z",
    fill: "#fa4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerCircleRed);
export default __webpack_public_path__ + "static/media/danger-circle-red.5baea5becf1e5c1704240e11648bf345.svg";
export { ForwardRef as ReactComponent };